import { AgTechActionButton, AgTechButton, AgTechButtonProps } from "@agtech/web/components/Buttons/AgTechButtons"
import ContactNoteActionMenu, { ContactNoteActionMenuProps } from "../menus/ContactNoteActionMenu";
import { ContactNote } from "@agtech/data/contacts/notes/ContactNoteData";
import { useContactNoteDataDeleteNoteAction } from "@agtech/data/contacts/notes/ContactNoteDataActions";

export const ContactNoteActionButton = (props: ContactNoteActionMenuProps) => {
    return (
        <AgTechActionButton>
            <ContactNoteActionMenu {...props} />
        </AgTechActionButton>
    )
}

export type ContactNoteRemovalButtonProps = AgTechButtonProps & {
    note: ContactNote
}

export const ContactNoteRemovalButton = (props: ContactNoteRemovalButtonProps) => {
    let noteDeleteAction = useContactNoteDataDeleteNoteAction();

    let buttonProps: AgTechButtonProps = {
        text: 'Delete Note',
        icon: 'fas fa-times',
        ...props,
        action: async e => await e.actions.executeDataActionInModal(noteDeleteAction, {
            originalEntity: props.note,
            submittedEntity: props.note
        })
    };

    return <AgTechButton {...buttonProps} />
}